import { render, staticRenderFns } from "./EventPlanDetails.vue?vue&type=template&id=972dd536&scoped=true"
import script from "./EventPlanDetails.vue?vue&type=script&lang=js"
export * from "./EventPlanDetails.vue?vue&type=script&lang=js"
import style0 from "./EventPlanDetails.vue?vue&type=style&index=0&id=972dd536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972dd536",
  null
  
)

export default component.exports